import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { pruneZeroBalanceLines } from '../utils';

import MiddleTable from './MiddleTable';
import MiddleTableChart from './MiddleTableChart';
function MiddleChart({
  queryData,
  accountStructure,
}) {
  const [collapsableData, setCollapsableData] = useState(null);  
  const [selectedDepth, setSelectedDepth] = useState(1);

  useEffect(() => {
    prepareData();
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [queryData, accountStructure]);

  const onResize = () => {
    // Force re-render
    setCollapsableData(prev => ({...prev}));
  };

  const prepareData = () => {
    let _collapsableData = {};
    if (queryData.Liability && accountStructure) {
      if (queryData.Liability.length > 0) {
        const data = queryData.Liability;

        let atData = _.mapValues(_.groupBy(data, 'AccountType'), (atlist) =>
          atlist.map((at) => _.omit(at, 'AccountType')),
        );

        _collapsableData['Total Liabilities'] = {};
        _collapsableData['Total Liabilities'].opening = 0;
        _collapsableData['Total Liabilities'].closing = 0;
        _collapsableData['Total Liabilities'].last = 1;

        accountStructure.subItems.forEach((account) => {
          Object.keys(atData).forEach((atkey) => {
            if (account.content === atkey) {
              _collapsableData[atkey] = {};
              _collapsableData[atkey].opening = 0;
              _collapsableData[atkey].closing = 0;
              _collapsableData[atkey].last = 0;

              let astData = _.mapValues(
                _.groupBy(atData[atkey], 'AccountSubType'),
                (astlist) =>
                  astlist.map((ast) => _.omit(ast, 'AccountSubType')),
              );

              account.subItems.forEach((subaccount) => {
                Object.keys(astData).forEach((astkey) => {
                  if (subaccount.content === astkey) {
                    _collapsableData[atkey][astkey] = {};
                    _collapsableData[atkey][astkey].opening = 0;
                    _collapsableData[atkey][astkey].closing = 0;
                    _collapsableData[atkey][astkey].last = 0;

                    astData[astkey].forEach((item) => {
                      const openingBalance = parseFloat(item.OpeningBalance);
                      const closingBalance = parseFloat(item.ClosingBalance);

                      _collapsableData['Total Liabilities'].opening += openingBalance;
                      _collapsableData['Total Liabilities'].closing += closingBalance;

                      _collapsableData[atkey].opening += openingBalance;
                      _collapsableData[atkey].closing += closingBalance;

                      _collapsableData[atkey][astkey].opening += openingBalance;
                      _collapsableData[atkey][astkey].closing += closingBalance;

                      if (!_collapsableData[atkey][astkey][item.AccountName]) {
                        _collapsableData[atkey][astkey][item.AccountName] = {};
                        _collapsableData[atkey][astkey][item.AccountName]['number'] = item.AccountNumber;
                        _collapsableData[atkey][astkey][item.AccountName]['closing'] = 0;
                        _collapsableData[atkey][astkey][item.AccountName]['opening'] = 0;
                        _collapsableData[atkey][astkey][item.AccountName]['last'] = 1;
                      }

                      _collapsableData[atkey][astkey][item.AccountName]['closing'] += closingBalance;
                      _collapsableData[atkey][astkey][item.AccountName]['opening'] += openingBalance;
                    });
                  }
                });
              });
            }
          });
        });
      }
    }

    if (Object.keys(_collapsableData).length > 0) {
      _collapsableData = pruneZeroBalanceLines(_collapsableData, 'Total Liabilities');

      // Move Total Liabilities to the end of the collapsableData
      let totalLiabilities = Object.assign({}, _collapsableData['Total Liabilities']);
      delete _collapsableData['Total Liabilities'];
      _collapsableData['Total Liabilities'] = totalLiabilities;
    }
    
    setCollapsableData(_collapsableData);
  };

  const height = (window.innerHeight - 100) / 5;
  const width = (window.innerWidth - 32) / 2;

  return (
    <div style={{
      minHeight: 150,
      marginTop: 10,
    }}>
      <div>
        <div className="subtitle mb-5" style={{ marginLeft: 2 }}>
            Liabilities
        </div>
        <Grid container spacing={2} style={{ paddingTop: 5 }}>
          <Grid size={6} style={{ minHeight: `${height}px` }}>
            <MiddleTable
              collapsableData={collapsableData}
              width={width}
              depth={0}
              setDepth={setSelectedDepth}
              selectedDepth={selectedDepth}
            />
          </Grid>

          <Grid size={6} style={{ minHeight: `${height}px` }}>            
            <MiddleTableChart
              collapsableData={collapsableData}
              width={width - 20}
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

MiddleChart.propTypes = {
  queryData: PropTypes.object.isRequired,
  accountStructure: PropTypes.object.isRequired,
};

export default MiddleChart;
